import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--text-primary);
`;

export const StyledText = styled.span`
  font-style: italic;
  font-size: 14px;
  color: var(--text-secondary);
`;

export const Notification = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled.span`
  color: var(--info);
`;
